module.exports = __webpack_public_path__ + "resources/sass/fn/fonts/OpenSans-Bold-webfont.woff";


//////////////////
// WEBPACK FOOTER
// ./src/resources/sass/fn/fonts/OpenSans-Bold-webfont.woff
// module id = 370
// module chunks = 0